(() => {
  const SELECTOR = '.mib-global-wishlist-btn';

  const normalizeBool = (v) => String(v).toLowerCase() === 'true';

  const apply = (btn) => {
    if (!(btn instanceof HTMLElement)) return;

    const active = normalizeBool(btn.getAttribute('data-mib-wishlist-active'));
    const loading = normalizeBool(btn.getAttribute('data-mib-wishlist-loading'));

    const labelAdd = btn.getAttribute('data-mib-label-add') || 'Add to Wishlist';
    const labelAdded = btn.getAttribute('data-mib-label-added') || 'Added to Wishlist';

    btn.setAttribute('aria-label', active ? labelAdded : labelAdd);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    btn.toggleAttribute('aria-disabled', loading);

    if (loading) btn.dataset.mibWishlistClickLock = '1';
    else delete btn.dataset.mibWishlistClickLock;
  };

  const initButton = (btn) => {
    if (!(btn instanceof HTMLElement)) return;
    if (btn.dataset.mibGlobalWishlistInit === '1') return;
    btn.dataset.mibGlobalWishlistInit = '1';

    apply(btn);

    const mo = new MutationObserver(() => apply(btn));
    mo.observe(btn, {
      attributes: true,
      attributeFilter: [
        'data-mib-wishlist-active',
        'data-mib-wishlist-count',
        'data-mib-wishlist-loading',
      ],
    });

    // Swallow the click only while a request is in flight. Stopping propagation
    // unconditionally would hide the click from the app's delegated listener,
    // and the card link is a sibling of this button, not an ancestor, so there
    // is nothing to shield it from.
    btn.addEventListener(
      'click',
      (e) => {
        if (btn.dataset.mibWishlistClickLock === '1') {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  };

  const scan = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initButton);
  };

  scan();

  const globalMO = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.(SELECTOR)) initButton(node);
        node.querySelectorAll?.(SELECTOR).forEach(initButton);
      }
    }
  });

  globalMO.observe(document.documentElement, { childList: true, subtree: true });
})();
